import React, { useEffect, useState } from 'react';

import {
  ContactItem,
  NextButton,
  LoadingIcon,
  LoadMoreContainer,
  LoadMore,
  ContactListContainer,
  HeaderTitle,
  HeaderSubtitle,
} from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { getEmails, getPhones } from './Steps-requests';
import arrowRight from '~/assets/images/ic_arrow.svg';

function SelectEmail(props) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [selectedContact, setSelectedContact] = useState(1);
  const [emails, setEmails] = useState([]);
  const emailsList = useSelector(state => state.accessReducer.emailsList);

  const firstAccessToken = useSelector(state => state.accessReducer.firstAccessToken);
  const access_token = useSelector(state => state.accessReducer.access_token);
  const location = useSelector(state => state.accessReducer.location);

  useEffect(() => {
    const removeDuplicates = (emails) => {
      const uniqueEmails = emails.reduce((acc, current) => {
        const x = acc.find(item => item.contact === current.contact);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);
      return uniqueEmails;
    };

    if (emailsList.length > 0) {
      setEmails(removeDuplicates(emailsList));
    } else {
      setLoading(true);
      getEmails(location, firstAccessToken, access_token)
        .then(res => {
          setEmails(removeDuplicates(res.data));
        })
        .catch(err => {
          console.error('Erro ao buscar emails:', err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [emailsList, location, firstAccessToken, access_token]);

  return (
    <div className="pb-3 h-100">
      <HeaderTitle>Selecione um e-mail de cadastro.</HeaderTitle>
      <HeaderSubtitle>Encontramos os seguintes:</HeaderSubtitle>
      <ContactListContainer>
        <ContactItem className="mb-3" onClick={() => setSelectedContact(1)}>
          <input
            type="radio"
            value="option1"
            style={{ marginRight: 10 }}
            checked={selectedContact === 1}
          />
          <span>Nenhuma das opções</span>
        </ContactItem>
        {emails.map(item => (
          <ContactItem
            id={item.contactId}
            key={item.contactId}
            className="mb-3"
            onClick={() => setSelectedContact(item.contactId)}
          >
            <input
              type="radio"
              value="option1"
              style={{ marginRight: 10 }}
              checked={item.contactId === selectedContact}
            />
            <span>{item.contact}</span>
          </ContactItem>
        ))}
        {emails.length >= 10 && (
          <LoadMoreContainer>
            <LoadMore>Carregar mais...</LoadMore>
          </LoadMoreContainer>
        )}
      </ContactListContainer>

      <NextButton
        onClick={() => {
          setLoading(true);
          if (selectedContact === 1) {
            getPhones(location, firstAccessToken, access_token)
              .then(res => {
                dispatch({ type: 'ADD_PHONELIST', phonesList: res.data });
                dispatch({ type: 'STEP', step: 3 });
              })
              .catch(err => {
                console.log('err =>', err);
                setLoading(false);
                dispatch({ type: 'STEP', step: 7 });
              })
              .finally(() => {
                setLoading(false);
              });
          } else {
            const selectedEmail = emails.find(email => email.contactId === selectedContact)?.contact || '';
            dispatch({
              type: 'ADD_CONTACT',
              email: selectedEmail,
              contactId: selectedContact,
            });
            dispatch({ type: 'STEP', step: 4 });
            setLoading(false);
          }
        }}
        disabled={loading}
      >
        {loading ? (
          <LoadingIcon className="fa fa-spinner fa-pulse fa-3x fa-fw" />
        ) : (
            <span>Avançar</span>
        )}
      </NextButton>
    </div>
  );
}

export default SelectEmail;
